<template>
  <page-template type="rightpanel" class="notifications-pages">
    <template v-slot:toolbar>
      <tool-bar @status-change="status = $event" type="statut-selector" title="Gestion des annonces" class="px-8"></tool-bar>
    </template>
    <template v-slot:central-panel-content>
      <div class="padding-x">
        <annonce-detail :advert-id="activeAdvert"></annonce-detail>
      </div>
    </template>
    <template v-slot:right-panel-content>
      <h2 class="text-uppercase text-center">Annonces</h2>
      <panel-right-notification
        type="annonces"
        v-for="advert in cachedAdverts"
        :key="advert._id"
        @click="activeAdvert = advert._id"
        :tenant="advert._id"
        :category="advert.category"
        :location="advert.location"
        :date="advert.date"
        class="[ope.activated ? 'on-going' : 'to-publish', active]"
      ></panel-right-notification>
    </template>
  </page-template>
</template>

<style lang="scss">
</style>

<script>
  import pageTemplate from '@/templates/PageTemplate.vue'
  import toolBar from '@/components/ToolBar.vue'
  import annonceDetail from '@/components/AnnonceDetail.vue'
  import panelRightNotification from '@/components/PanelRightNotification.vue'
  import axios from 'axios'
  import { apiURL } from '@/../config'
  export default {
    name: 'Annonces',
    components: { pageTemplate, toolBar, annonceDetail, panelRightNotification },
    data: () => {
      return {
        status: 'ongoing',
        adverts: [],
        activeAdvert: ''
      }
    },
    async created () {
      try {
        // ALL ADVERTS
        const advertsRes = await axios.get(`${apiURL}/neighborhood/ads/pagination/all/1`)
        this.adverts = advertsRes.data.model
        // SET INITIAL ACTIVE ADVERT
        this.activeAdvert = this.adverts[0]
      } catch (e) {
        alert('Une erreur est survenue, veuillez réessayer.')
        console.log(e)
      }
    },
    computed: {
      cachedAdverts () {
        if (!this.adverts.length) return []
        return this.adverts.filter(a => {
          return a.status === this.status
        })
      }
    }
  }
</script>